import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function NotFound() {
  return (
    <>
      <SEO page="notFound" canonical={window.location.pathname} />
      <section className="not-found">
        <div className="container">
          <p className="eyebrow">404</p>
          <h1>This suite is not on the directory.</h1>
          <p>The page may have moved, or the address may be incomplete.</p>
          <div className="not-found__links">
            <Link className="button" to="/">Return home</Link>
            <Link className="text-link" to="/directory/">Browse professionals</Link>
            <Link className="text-link" to="/contact/">Contact Diamond Suites</Link>
          </div>
        </div>
      </section>
    </>
  )
}
